import { render, staticRenderFns } from "./TwProcessListPreviewLc.vue?vue&type=template&id=24ffe3c7&scoped=true&"
import script from "./TwProcessListPreviewLc.vue?vue&type=script&lang=js&"
export * from "./TwProcessListPreviewLc.vue?vue&type=script&lang=js&"
import style0 from "./TwProcessListPreviewLc.vue?vue&type=style&index=0&id=24ffe3c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ffe3c7",
  null
  
)

export default component.exports